import { render, staticRenderFns } from "./phonePwd.vue?vue&type=template&id=60d350d2&scoped=true"
import script from "./phonePwd.vue?vue&type=script&lang=js"
export * from "./phonePwd.vue?vue&type=script&lang=js"
import style0 from "./phonePwd.vue?vue&type=style&index=0&id=60d350d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d350d2",
  null
  
)

export default component.exports